import type { FieldValues, Path, UseFormSetError } from "react-hook-form";
import type { ValidationError } from "./authFetch";

export type FormError<T extends FieldValues> = {
  path: Path<T>;
  message: string;
};

export const toFormErrors = <T extends FieldValues>(
  errors: ValidationError[],
  stripPrefix?: string,
): FormError<T>[] => {
  return errors.map((error) => {
    let path = error.propertyPath;
    if (stripPrefix && path.startsWith(`${stripPrefix}.`)) {
      path = path.slice(stripPrefix.length + 1);
    }
    return { path: path as Path<T>, message: error.message };
  });
};

export const setFormErrors = <T extends FieldValues>(
  errors: FormError<T>[],
  setError: UseFormSetError<T>,
) => {
  errors.forEach((error, index) => {
    setError(
      error.path,
      {
        type: "manual",
        message: error.message,
      },
      { shouldFocus: index === 0 },
    );
  });
};
